// extracted by mini-css-extract-plugin
export default {"uploadSection":"ownershipAllocationsUpload_uploadSection__WTyR2"};